import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Dashboard from './pages/Dashboard'
import Landing from './pages/Landing'
import Interpretation from './pages/Interpretation'
import { Toaster } from './components/ui/toaster'

const queryClient = new QueryClient()

// Component to handle scrolling to hash anchors
function ScrollToHash() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      // Scroll to top first to prevent weird scroll behavior
      window.scrollTo(0, 0)
      // Longer delay to ensure the page has fully rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash)
        if (element) {
          element.scrollIntoView({ behavior: 'auto', block: 'start' })
        }
      }, 200)
    } else {
      // No hash, scroll to top
      window.scrollTo(0, 0)
    }
  }, [location])

  return null
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/takeaways" element={<Interpretation />} />
          <Route path="/about" element={<Landing />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
